export class SentryNotifierException extends Error {
  constructor(public message: string) {
    super(message);

    this.name = 'RtkQueryError';

    Object.setPrototypeOf(this, SentryNotifierException.prototype);
  }
}
